import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from '@zurich/common/hooks';
import { FormFlex, Tag } from '@zurich/ui/legacy/components';
import { useTheme } from '@zurich/ui/legacy/hooks';
import { approvalStateUtils, offerStateUtils, } from '@zurich-client/typeutils/contract';
const approvalStates = [
    'applicationApprovalPending',
    'applicationApprovalDeclined',
    'applicationApprovalApproved',
];
export const OfferStateTag = ({ offerState }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const stateToColorMap = useMemo(() => ({
        ['active']: theme.palette.success.main,
        ['applicationApprovalApproved']: theme.palette.secondary.main,
        ['applicationApprovalDeclined']: theme.palette.secondary.main,
        ['applicationApprovalPending']: theme.palette.secondary.main,
        ['applicationApprovalDeclinedAndCounterOffer']: theme.palette.secondary.main,
        ['applicationCompleted']: theme.palette.secondary.main,
        ['applicationApprovalApproval']: theme.palette.secondary.main,
        ['applicationSigned']: theme.palette.teal['A100'],
        ['applicationUnsigned']: theme.palette.primary.lighter,
        ['bindingOffer']: theme.palette.azure[100],
        ['calculationState']: theme.palette.secondary.main,
        ['canceled']: theme.palette.grey[200],
        ['concept']: theme.palette.secondary.main,
        ['paid']: theme.palette.success.main,
        ['policy']: theme.palette.purple.light,
        ['policingPending']: theme.palette.grey[200],
        ['notConcluded']: theme.palette.grey[200],
        ['unbindingOffer']: theme.palette.secondary.main,
        ['correction']: theme.palette.warning.main,
        ['alternativeOffer']: theme.palette.warning.main,
    }), [
        theme.palette.azure,
        theme.palette.grey,
        theme.palette.primary.lighter,
        theme.palette.purple.light,
        theme.palette.secondary.main,
        theme.palette.success.main,
        theme.palette.teal,
        theme.palette.warning,
    ]);
    const approvalStateToColorMap = useMemo(() => ({
        ['applicationApprovalApproved']: theme.palette.success.main,
        ['applicationApprovalDeclined']: theme.palette.error.main,
        ['applicationApprovalPending']: theme.palette.groupPrimary.orange100,
    }), [
        theme.palette.error.main,
        theme.palette.groupPrimary.orange100,
        theme.palette.success.main,
    ]);
    return (_jsxs(FormFlex, { rowGap: 1, columnGap: 1, flexGrow: 0, children: [_jsx(Tag, { backgroundColor: stateToColorMap[offerState], small: true, textColor: theme.palette.grey['A100'], children: offerStateUtils.getTranslatedValue(t, offerState) }), approvalStates.includes(offerState) && (_jsx(Tag, { backgroundColor: approvalStateToColorMap[offerState], small: true, textColor: theme.palette.grey['A100'], children: approvalStateUtils.getTranslatedValue(t, offerState) }))] }));
};
